module.exports = __webpack_public_path__ + "src/img/artist/work07_2.jpg?48ed3f814ae5677fb4b4f745be0681ac";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work07_2.jpg
// module id = 159
// module chunks = 0